// extracted by mini-css-extract-plugin
export default {"inputBox":"CallCenterContentHeader_inputBox__HdLlt"};